import { h } from 'hyperapp'; // eslint-disable-line no-unused-vars
import './index.scss';

const DEFAULT_PLACEHOLDER_TEXT = 'Placeholder';

export const Dropdown = ({
    placeholder = DEFAULT_PLACEHOLDER_TEXT,
    items,
    onchange,
    className,
    selectedOption = { value: '', label: '' },
    parentElement,
}) => {
    const close = e => {
        Array.prototype.forEach.call(document.querySelectorAll('.apc-dropdown.is-active'), item => {
            if (!item.contains(e.target)) {
                item.classList.remove('is-active');
            }
        });
    };

    const oncreate = () => {
        document.addEventListener('click', close);
    };

    const ondestroy = () => {
        document.removeEventListener('click', close);
    };

    const toggle = () => {
        parentElement.querySelector('.apc-dropdown').classList.toggle('is-active');
    };

    const select = val => e => {
        const selected = e.currentTarget;

        Array.prototype.forEach.call(selected.parentElement.childNodes, c => c.classList.remove('is-active'));

        selected.classList.add('is-active');

        const text = parentElement.querySelector('.apc-dropdown .apc-dropdown__selected-text');
        text.innerText = selected.innerText;

        toggle(e);
        onchange(val);
    };

    const change = e => {
        select(e.target.value)(e);
    };

    const renderMobileDropdownMenuOption = (item, index) => (
        <option key={index} value={item.value} selected={selectedOption.value === item.value}>
            {item.label}
        </option>
    );

    const renderDropdownOption = (item, index) => (
        <a
            key={index}
            data-value={item.value}
            class={`dropdown-item ${selectedOption.value === item.value ? 'is-active' : ''}`}
            onclick={select(item.value)}
        >
            {item.label}
        </a>
    );

    const onKeyDown = e => {
        if (e.keyCode === 32 || e.keyCode === 40 || e.keyCode === 38) {
            toggle(e);
        }
    };

    return (
        <div class={`apc-dropdown ${className}`} oncreate={oncreate} ondestroy={ondestroy}>
            <div class="dropdown-trigger" onclick={toggle} tabindex="0" onkeydown={onKeyDown}>
                <div class="button" aria-haspopup="true" aria-controls="dropdown-menu-3">
                    <span class="apc-dropdown__placeholder-text ">{placeholder}</span>
                    <span class="apc-dropdown__selected-text">{selectedOption.label}</span>
                    <span class="icon is-small">
                        <i class="fa fa-angle-down" aria-hidden="true" />
                    </span>
                </div>
            </div>
            <div class="dropdown-trigger dropdown-trigger__mobile">
                <select class="apc-dropdown__mobile-menu dropdown-trigger" onchange={change}>
                    {items.map(renderMobileDropdownMenuOption)}
                </select>
            </div>
            <div class="apc-dropdown-menu" id="apc-dropdown-menu" role="menu">
                <div class="dropdown-content">{items.map(renderDropdownOption)}</div>
            </div>
        </div>
    );
};
